import Promise from 'bluebird';
import pageContext from '@bingads-webui-static-legacy/page-context';
import odata from '@bingads-webui-component-legacy/http/channel/odata';

export function fetchHasAvailableConversionGoals() {
  const url = `/Customers(${pageContext.CurrentAccount.AdvertiserCustomerID})/Accounts(${pageContext.CurrentAccount.Id})/ConversionGoalDetails`;

  return odata.get(url, {
    path: 'Advertiser/V2',
  }).then((response) => {
    return response.IsActiveConversionGoalPresent;
  });
}

function fetchSmartShoppingCampaignCountIsLessThan100() {
  const url = `/Customers(${pageContext.CurrentAccount.AdvertiserCustomerID})/Accounts(${pageContext.CurrentAccount.Id})/Campaigns/Default.GetCampaignsCount(campaignType='Shopping',campaignSubType='ShoppingSmartAds')`;

  return odata.get(url, {
    path: 'Advertiser/V2',
  }).then((response) => {
    return response && response.value && response.value[0] < 100;
  });
}

export const noSmartShoppingReason = {
  NO_AVAILABLE_GOAL: 'NO_AVAILABLE_GOAL',
  MORE_THAN_100: 'MORE_THAN_100',
  NO_PILOT: 'NO_PILOT',
};

export function fetchIsSmartShoppingCampaignSupported() {
  const isSmartShoppingCampaignEnabled = pageContext.Permissions.IsSmartShoppingCampaignEnabled;

  if (!isSmartShoppingCampaignEnabled) {
    return Promise.resolve({
      supported: false,
      reason: noSmartShoppingReason.NO_PILOT,
    });
  }

  return new Promise((resolve) => {
    Promise.all([
      fetchHasAvailableConversionGoals(),
      // fetchHasUETTag(),
      fetchSmartShoppingCampaignCountIsLessThan100(),
    ]).then(([hasAvailableConversionGoal, isSSCCountLessThan100]) => {
      const supported = hasAvailableConversionGoal && isSSCCountLessThan100;
      let reason;

      if (!supported) {
        if (!hasAvailableConversionGoal) { // eslint-disable-line
          reason = noSmartShoppingReason.NO_AVAILABLE_GOAL;
        } else {
          reason = noSmartShoppingReason.MORE_THAN_100;
        }
      }
      resolve({
        supported,
        reason,
      });
    }).catch(() => {
      resolve({
        supported: false,
        reason: null,
      });
    });
  });
}
